// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"807":"5f940986","961":"5f940986"}[chunkId] + ".chunk.css";
};